"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var getWeatherImage_1 = require("../utils/getWeatherImage");
var store_1 = require("../store/store");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var owa_strings_1 = require("owa-strings");
var react_1 = require("satcheljs/lib/legacy/react");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var styles = require('./UpNextExpansion.scss');
var classNames = require('classnames/bind');
var UpNextExpansion = /** @class */ (function (_super) {
    tslib_1.__extends(UpNextExpansion, _super);
    function UpNextExpansion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpNextExpansion.prototype.render = function () {
        var _this = this;
        return (this.props.weatherDailyConditions && (React.createElement("a", { className: styles.container, href: store_1.default.weatherClickThrough, target: "_blank" }, this.props.weatherDailyConditions.map(function (item, index) {
            if (index > 0) {
                // We do not care about the item at index 0 as it is the weather for
                // Now. From index 1 forward they will represent: today, tomorrow, etc.
                var precipitationChance = parseInt(item.PrecipitationChance);
                var weatherCharmClasses = classNames(!!precipitationChance && styles.withPrecipitation, getWeatherImage_1.default(item.SkyCode), getWeatherImage_1.default()); // Fallback css image.
                return (React.createElement("div", { className: styles.weather },
                    React.createElement("div", { className: styles.day }, _this.getDayShortName(index)),
                    React.createElement("div", { key: 'wi' + index, className: weatherCharmClasses, title: item.SkyText }, !!precipitationChance && (React.createElement("span", null,
                        React.createElement(Icon_1.Icon, { className: styles.drop, iconName: "Drop" /* Drop */ }),
                        owa_strings_1.format(owa_common_strings_1.default.percentage, precipitationChance)))),
                    React.createElement("div", { className: styles.high },
                        owa_strings_1.format(owa_common_strings_1.default.temperature, item.High),
                        React.createElement("span", { className: styles.low }, owa_strings_1.format(owa_common_strings_1.default.temperature, item.Low)))));
            }
            else {
                return null;
            }
        }))));
    };
    UpNextExpansion.prototype.getDayShortName = function (index) {
        var dayIndex = (new Date().getDay() + (index - 1)) % 7;
        switch (dayIndex) {
            case 0:
                return owa_common_strings_1.default.sundayShort;
            case 1:
                return owa_common_strings_1.default.mondayShort;
            case 2:
                return owa_common_strings_1.default.tuesdayShort;
            case 3:
                return owa_common_strings_1.default.wednesdayShort;
            case 4:
                return owa_common_strings_1.default.thursdayShort;
            case 5:
                return owa_common_strings_1.default.fridayShort;
            case 6:
                return owa_common_strings_1.default.saturdayShort;
        }
        // Unreachable point.
        return null;
    };
    UpNextExpansion = tslib_1.__decorate([
        react_1.reactive({
            weatherClickThrough: function () { return store_1.default.weatherClickThrough; },
            weatherDailyConditions: function () { return store_1.default.weatherDailyConditions; },
        })
    ], UpNextExpansion);
    return UpNextExpansion;
}(React.Component));
exports.default = UpNextExpansion;
//# sourceMappingURL=UpNextExpansion.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/components/UpNextExpansion.js
// module id = 4824
// module chunks = 48